<div *ngIf="!isHealthy" class="unhealthy-banner">
  The system is currently experiencing issues. Some functionalities may not be available.
</div>
